<template>
  <div>
      <h3>
          Fire Alarm Monthly Test and Inspection Record (Reference Clauses 4.7 and  5.2.1, CAN/ULC-S536-13)
      </h3>
      <h4>
          Legend
      </h4>
      <p>
            1A.  System Trouble Signal Indicator 'OFF'.
            <br>
            1B.  Power Indication Lamp 'ON'.
            <br>
            2A.  Inspection of one initiating field device - Rotational
            <br>
            2B.  Alert/Alarm Signal confirmed - Rotational
            <br>
            2C.  Annunciator:  Tested device annunciates 
            <br>
            2D.  Audible and visual trouble signal  
            <br>
            3A.  Confirmation of alarm trransmission
            <br>
            4A.  Test (rotational):  One emergency telephone for two-way communication and indication
            <br>
            4B.  Test (rotational):  Voice paging to one zone.
            <br>
            *  Fire Code regulations require that these records be retained a minimum of two years. 
            <br>
            *  Tests to be conducted in accordance with CAN/ULC-S536 and Ontario Fire Code.
            <br>
            *  The monthly test is not required during the month  that the annual test is completed.
      </p>
  </div>
</template>

<script>
export default {
    name : 'AFAS_3_Monthly2020',
}
</script>

<style>

</style>